var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRotateRight = function SvgRotateRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 30,
    height: 27,
    viewBox: "0 0 1.98 1.76",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.33;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2314198877152"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M1.78.88C1.52.7 1.41.63 1.1.57.83.52.41.83.25 1.05c-.08.1-.12.47-.06.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M1.6.16c.01.1.22.73.22.73-.17.06-.38.19-.57.26-.01 0-.06.03-.06.03"
  })))));
};

export default SvgRotateRight;